import {ApiUrls} from 'shared/config/model/urls';

export interface IExportItem {
    kind: string;
    url: string;
    label: string;
    menuLabel: string;
    entityName: string;
}

export const EXPORT_ITEMS: IExportItem[] = [
    {
        kind: 'users',
        url: ApiUrls.USERS_EXPORT,
        label: 'Пользователей',
        menuLabel: 'Экспорт пользователей',
        entityName: 'пользователей',
    },
    {
        kind: 'monitors',
        url: ApiUrls.MONITORS_EXPORT_ALL,
        label: 'Мониторов',
        menuLabel: 'Экспорт мониторов',
        entityName: 'мониторов',
    },
    {
        kind: 'domain-monitors',
        url: ApiUrls.DOMAIN_MONITORS_EXPORT_ALL,
        label: 'Мониторов доменов',
        menuLabel: 'Экспорт мониторов доменов',
        entityName: 'мониторов доменов',
    },
];
